import { render, staticRenderFns } from "./ChatExpertList.vue?vue&type=template&id=57854929&scoped=true"
import script from "./ChatExpertList.vue?vue&type=script&lang=js"
export * from "./ChatExpertList.vue?vue&type=script&lang=js"
import style0 from "./ChatExpertList.vue?vue&type=style&index=0&id=57854929&prod&scoped=true&lang=scss"
import style1 from "./ChatExpertList.vue?vue&type=style&index=1&id=57854929&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57854929",
  null
  
)

export default component.exports